const BASE_URL = window.APP_IDENTITY?.API_BASE_URL || import.meta.env.VITE_API_BASE_URL;

/**
 * Generic fetch wrapper for IanKing Backend
 * @param {string} route - The route name (e.g., 'user', 'joborder')
 * @param {string} method - The POST method name to call in the PHP controller
 * @param {Object} params - Additional parameters to send
 */
export async function apiPost(route, method, params = {}) {
    const formData = new FormData();
    formData.append('method', method);

    Object.entries(params).forEach(([key, value]) => {
        formData.append(key, value);
    });

    // Automatically append branch identity from global config if not explicitly provided
    const branch_cd = window.APP_IDENTITY?.BRANCH_CD;
    if (branch_cd && !params.branch_cd) {
        formData.append('branch_cd', branch_cd);
    }

    try {
        const response = await fetch(`${BASE_URL}${route}`, {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error(`API Error (${route}/${method}):`, error);
        throw error;
    }
}
